import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { completeOAuth } from '../api/oauth';
export default function OAuthCallback() {
  const started = useRef(false);
  const [error, setError] = useState('');
  useEffect(() => {
    if (started.current) return;
    started.current = true;
    completeOAuth(window.location.search).then(destination => window.location.replace(destination || '/dashboard')).catch(() => setError('Sign-in could not be completed. Please start again.'));
  }, []);
  return <main className="p-8"><h1>{error || 'Completing sign-in…'}</h1>{error && <Link to="/signin">Return to sign in</Link>}</main>;
}
